"use client";

import type { ReactNode } from "react";

import Header from "@/components/marketing/linear/ui/header";
import { ChromeFooter } from "@/components/platform/ChromeFooter";
import { cn } from "@/lib/utils";

type MarketingPageShellProps = {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  footerClassName?: string;
};

/** Public guest pages — landing nav + a little space before content (not hero-sized gap). */
const PUBLIC_MAIN_TOP = "pt-[var(--marketing-subpage-main-top)]";

/**
 * Shared chrome for marketing subpages. Navbar placement matches the landing page.
 */
export function MarketingPageShell({
  children,
  className,
  contentClassName,
  footerClassName,
}: MarketingPageShellProps) {
  return (
    <div
      className={cn(
        "marketing-linear-page min-h-[100svh] bg-[#050505] text-[var(--color-text-primary)]",
        className,
      )}
    >
      <Header />
      <main className={cn(PUBLIC_MAIN_TOP, contentClassName)}>{children}</main>
      <ChromeFooter
        className={cn(
          "border-white/[0.06] text-neutral-500 [&_a]:text-neutral-500 [&_a:hover]:text-neutral-200",
          footerClassName,
        )}
      />
    </div>
  );
}
